// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__gE0B9","overlay-show":"Modal_overlay-show__cozIx","content":"Modal_content__aobLq","content-show":"Modal_content-show__ZS7GA"};